export function whiteSpaceCase(data) {
  // ホワイトスペース ⇒ Null
  for(const key in data){
    if(typeof data[key] === 'string'){
      if(data[key].trim() === ''){
        data[key] = null;
      }
    }
    else{
      if(data[key] === ''){
          data[key] = null;
      }
    }
  }
  return data;
}